"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { knowledgeBase as data } from "@/lib/data/support";

const accent = "var(--color-purple)";
const catAccents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-amber)", "var(--color-emerald)", "var(--color-amber)", "var(--color-cyan)", "var(--color-emerald)"];

export function KnowledgeBase() {
  return (
    <Section id="knowledge-base" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3">
          {data.categories.map((c, i) => {
            const c1 = catAccents[i % catAccents.length]!;
            return (
              <Reveal key={c.category} delay={i * 50}>
                <div className="glass rounded-2xl p-5 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${c1} 12%, transparent)` }}>
                  <div className="text-2xl font-bold" style={{ color: c1 }}>{c.articles}</div>
                  <div className="mt-1 text-sm font-semibold" style={{ color: c1 }}>{c.category}</div>
                  <div className="mt-1 text-[10px] text-[rgb(var(--fg-subtle))] uppercase tracking-wider">Updated {c.updates}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={300}>
          <div className="mt-8 glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
            <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Knowledge Base Features</span>
            <ul className="mt-3 grid sm:grid-cols-2 gap-1.5">
              {data.features.map((f, i) => (
                <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{f}</li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
